import collectionService from '../../services/ClassenService/modules/collectionService';

const state = {
  collections: [],
};

const mutations = {};

const getters = {};

const actions = {
  getCollections: ({commit}) => new Promise((resolve, reject) => {
    collectionService.getCollections()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getCollection: ({commit}, collectionId) => new Promise((resolve, reject) => {
    collectionService.getCollection(collectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateCollection: ({commit}, collectionId, collectionData) => new Promise((resolve, reject) => {
    collectionService.updateCollection(collectionId, collectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteCollection: ({commit}, collectionId) => new Promise((resolve, reject) => {
    collectionService.deleteCollection(collectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addCollection: ({commit}, collectionData) => new Promise((resolve, reject) => {
    collectionService.addCollection(collectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
